import type {
  ComponentSettings,
  ComponentSettingsProps,
} from "@repo/editor/externalComponents";
import type { ComponentType } from "@repo/editor/types";
import { forwardRef } from "react";
import * as t from "@rekajs/types";
import { useApp } from "@repo/app/useApp";
import { observer } from "mobx-react-lite";

const ContactDetailItemDefinition: ComponentSettingsProps = {
  title: {
    type: "string",
    label: "عنوان",
    default: "عنوان",
  },
  description: {
    type: "string",
    label: "توضیحات",
    default: "توضیحات",
  },
  icon: {
    type: "image",
    label: "آیکون",
    default: "/images/placeholder.png",
  },
  link: {
    type: "string",
    label: "لینک",
  },
};

interface ContactDetailItemProps {
  title: string;
  description: string;
  icon: string;
  link?: string;
}

const ContactDetailItemComponent = forwardRef(
  (props: ContactDetailItemProps, ref: React.Ref<HTMLDivElement>) => {
    const app = useApp();
    const isEditor = app.rendererMode === "editor";
    return (
      <div className="flex gap-3 md:gap-4 lg:gap-6 items-center" ref={ref}>
        <a
          className="flex gap-3 md:gap-4 lg:gap-6 items-center"
          href={props.link}
          onClick={(e) => {
            if (isEditor) {
              e.preventDefault();
            }
          }}
        >
          <img
            alt=""
            className="w-10 h-10 object-contain"
            src={props.icon || String(ContactDetailItemDefinition.icon.default)}
          />
          <div className="font-helvetica rtl:font-doran rtl:font-medium flex flex-col text-[10.8px] md:text-[15px] lg:text-[20px]">
            <h5 className="uppercase text-[#4c4c4c]">
              {props.title || String(ContactDetailItemDefinition.title.default)}
            </h5>
            <p className="text-[#f70]">
              {props.description ||
                String(ContactDetailItemDefinition.description.default)}
            </p>
          </div>
        </a>
      </div>
    );
  }
);

ContactDetailItemComponent.displayName = "ContactDetailItem";

export const ContactDetailItem = observer(
  ContactDetailItemComponent
) as unknown as ComponentType<ContactDetailItemProps>;
export const contactDetailItemSettings: ComponentSettings = {
  name: "EContactDetailItem",
  props: ContactDetailItemDefinition,
  label: "آیتم جزئیات تماس با ما",
  childrenAllowed: false,
  widgets: {
    label: "آیتم جزئیات تماس با ما",
    template: () =>
      t.componentTemplate({
        component: t.identifier({ name: "EContactDetailItem", external: true }),
      }),
  },
};

ContactDetailItem.componentSettings = contactDetailItemSettings;
